import { render, staticRenderFns } from "./openClass.vue?vue&type=template&id=21706dd2&scoped=true"
import script from "./openClass.vue?vue&type=script&lang=js"
export * from "./openClass.vue?vue&type=script&lang=js"
import style0 from "./openClass.vue?vue&type=style&index=0&id=21706dd2&prod&lang=less"
import style1 from "./openClass.vue?vue&type=style&index=1&id=21706dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21706dd2",
  null
  
)

export default component.exports